import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Modal,
  ModalHeader
} from 'reactstrap'
import { FormattedMessage } from 'react-intl'

const Header = styled(ModalHeader)`
  background-color: #00a79d;
  color: #fff;
  text-transform: uppercase;

  & .modal-title {
    font-size: 1.2rem;
    font-weight: 400;
  }
`

const ModalPopUp = ({ children, show, onToggle, className, title }) =>
  <Modal
    className={className}
    zIndex='2000'
    isOpen={show}
    toggle={onToggle}>
    <Header toggle={onToggle}>
      <FormattedMessage id={title} />
    </Header>
    {children}
  </Modal>

ModalPopUp.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired
}

export default ModalPopUp



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/Modal.js